import axios from "@/libs/api.request";
// 获取列表
export const getParams = params => {
  return axios.request({
    url: "/tracker/params",
    params,
    method: "get"
  });
};
// 创建列表
export const addParams = data => {
  return axios.request({
    url: "/tracker/params",
    data,
    method: "post"
  });
};
// 获取详情
export const getParamsDetails = params => {
  return axios.request({
    url: `/tracker/params/${params.id}`,
    method: "GET"
  });
};
// 更新列表
export const updateParams = data => {
  return axios.request({
    url: `/tracker/params/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const delParams = data => {
  return axios.request({
    url: `/tracker/params/${data.id}`,
    method: "DELETE"
  });
};


// 获取操作记录
export const fetchOperationLog = (data, type = 'normal') => {
  return axios.request({
    url: `/tracker/operation`,
    method: "POST",
    data: {
      mawb: data,
      type
    }
  });
}
